import { required, maxLength, requiredIf } from "vuelidate/lib/validators";
import AIModelService from "../../../services/AIModel.service";
import { alertResponseSuccess, alertResponseError } from "../../../helpers/general";
import AIModelField from "../ai_model_field/AIModelField";
import { AI_MODEL_TYPE, SUMMARIZE_PERIOD } from "../../../const/aimodel";
import { ERRORS_CODE } from "../../../const/error_code";

export default {
    components: {
        appAIModelField: AIModelField,
    },
    data() {
        return {
            isCreate: true,
            formSubmitted: false,
            errors: {},
            aiModelData: [],
            aiModelSavingPredictionData: [],
            isGetKintoneField: false,
            aiModel: {
                id: '',
                name: '',
                kintone_sub_domain: '',
                kintone_domain: 'cybozu.com',
                kintone_login_name: '',
                kintone_password: '',
                kintone_app_id: '',
                kintone_app_name: '',
                kintone_app_id_2: '',
                kintone_app_name_2: '',
                kintone_basic_username: '',
                kintone_basic_password: '',
                type: AI_MODEL_TYPE.neural_network,
                summarize_period: SUMMARIZE_PERIOD.monthly,
                summarize_kintone_field_name: '',
                summarize_kintone_field_code: '',
                summarize_kintone_field_type: '',
            },
            aiSummarizeDateField: {},
            AI_MODEL_TYPE: AI_MODEL_TYPE
        }
    },
    methods: {
        handleForm() {
            this.errors = {};
            this.formSubmitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return false;
            } else {
                if (this.isCreate) {
                    return this.createAIModel();
                } else {
                    return this.updateAIModel();
                }
            }
        },
        createAIModel() {
            AIModelService.createAIModel(this.aiModel).then((response) => {
                this.formSubmitted = false;
                if (response.data.success) {
                    alertResponseSuccess(this.$t("common_message.create_success"));
                    this.$router.push({ name: 'aimodel-list' });
                    this.aiModel.id = response.data.data.id;
                    this.updateKintoneFields(response.data.data.id)
                }
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.CANNOT_REGISTER_USER_WITHOUT_ORGANIZATION) {
                    alertResponseError(this.$t("message_error.CANNOT_REGISTER_USER_WITHOUT_ORGANIZATION"));
                } else if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_NOT_FOUND) {
                    alertResponseError(this.$t("message_error.SUBSCRIPTION_NOT_FOUND"));
                } else if (error.response.data.errorCode === ERRORS_CODE.NO_PLAN_SUBSCRIBE) {
                    alertResponseError(error.response.data.msg);
                } else if (error.response.data.errorCode === ERRORS_CODE.ORGANIZATION_IS_MAX_AI_MODEL_VOLUME) {
                    alertResponseError(this.$t("message_error.ORGANIZATION_IS_MAX_AI_MODEL_VOLUME"));
                } else if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_IS_NOT_ACTIVE) {
                    alertResponseError(this.$t("message_error.SUBSCRIPTION_IS_NOT_ACTIVE"));
                } else if (error.response.data.errorCode === ERRORS_CODE.ORGANIZATION_NOT_FOUND) {
                    alertResponseError(this.$t("message_error.CAN_NOT_START_PLAN"));
                } else {
                    alertResponseError(error);
                }
            });
        },
        getAIModelWithId(id) {
            return AIModelService.getAIModelWithId(id).then((response) => {
                this.aiModel = response.data.data;
                if(this.aiModel.summarize_kintone_field_code !== '') {
                    this.aiSummarizeDateField = {
                        label: this.aiModel.summarize_kintone_field_name,
                        code: this.aiModel.summarize_kintone_field_code,
                        type: this.aiModel.summarize_kintone_field_type
                    }
                } else {
                    this.aiSummarizeDateField = {};
                }
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_NOT_FOUND) {
                    this.aiModel.kintone_app_name = '';
                    this.aiModel.kintone_app_name_2 = '';
                    alertResponseError(this.$t("ai_model_detail.ai_model_not_found"));
                } else {
                    this.aiModel.kintone_app_name = '';
                    this.aiModel.kintone_app_name_2 = '';
                    alertResponseError(error);
                }
            });
        },
        getKintoneFields() {
            this.formSubmitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return false;
            } else {
                if (this.isGetKintoneField) {
                    return;
                } else {
                    this.isGetKintoneField = true;
                    this.formSubmitted = false;
                    return AIModelService.getKintoneFields(this.aiModel).then((response) => {
                        this.isGetKintoneField = false;
                        if (response.data.success) {
                            this.aiModel.kintone_app_name = response.data.data.kintone_app_name.detail.name;
                            
                            // copy the saved feature importance value
                            if (response.data.data.fields && response.data.data.fields.detail && response.data.data.fields.detail.properties) {
                                for (let field_code in response.data.data.fields.detail.properties) {
                                    let matched_field = this.aiModelData.filter((item) => {
                                        return field_code === item.code
                                    })
                                    if (matched_field.length == 1) {
                                        response.data.data.fields.detail.properties[field_code]["feature_importance"] = matched_field[0]["feature_importance"]
                                    }
                                }
                            }

                            this.aiModelData = response.data.data.fields.detail.properties;
                            
                            if (response.data.data.kintone_app_name_2)
                                this.aiModel.kintone_app_name_2 = response.data.data.kintone_app_name_2.detail.name;

                            if (response.data.data.fields_2)
                                this.aiModelSavingPredictionData = response.data.data.fields_2.detail.properties;
                        }
                    }).catch((error) => {
                        this.aiModel.kintone_app_name = '';
                        this.aiModel.kintone_app_name_2 = '';
                        this.isGetKintoneField = false;
                        if (error.response.data.errorCode === ERRORS_CODE.UNKNOWN_ERROR) {
                            alertResponseError(error.response.data.data.fields.detail.message)
                        } else if (error.response.data.errorCode === ERRORS_CODE.VALIDATION_ERROR) {
                            alertResponseError(this.$t("message_error.DOMAIN_OR_SUBDOMAIN_INVALID"))
                        } else {
                            alertResponseError(error)
                        }
                    });
                }
            }
        },
        getListInputsAndOutput(id) {
            return AIModelService.getInputsAndOutputWithAiModelId(id).then((response) => {
                let  data = []; 
                data = data.concat(response.data.data.inputs, response.data.data.outputs)
                this.aiModelData = this.mapDataToKintoneField(data);
                this.$refs.aiModelField.aiModelOutputs = this.mapDataToKintoneField(response.data.data.outputs);
                this.$refs.aiModelField.aiModelInputSelectedCodes = this.mapDataToKintoneField(response.data.data.inputs).map((item) => {
                    return item.code;
                });
            }).catch((error) => {
                if (error.response.data.errorCode === ERRORS_CODE.AI_MODEL_NOT_FOUND) {
                    alertResponseError(this.$t("ai_model_detail.ai_model_not_found")).then((value) => {
                        if (value) {
                            this.$router.push({ name: 'aimodel' });
                        }
                    });
                } else {
                    alertResponseError(error);
                }
            })
        },
        updateAIModel() {
            return AIModelService.updateAIModel(this.aiModel.id, this.aiModel).then((response) => {
                this.formSubmitted = false;
                if (response.data.success) {
                    alertResponseSuccess(this.$t("common_message.update_success"));
                    this.updateKintoneFields(this.aiModel.id);
                }
            }).catch((error) => {
                if(error.response.data.errorCode === ERRORS_CODE.NO_PLAN_SUBSCRIBE) {
                    alertResponseError(this.$t("message_error.CAN_NOT_CREATE_OR_EDIT_AI_MODEL"));
                }  else if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_NOT_FOUND) {
                    alertResponseError(this.$t("message_error.SUBSCRIPTION_NOT_FOUND"));
                } else if (error.response.data.errorCode === ERRORS_CODE.SUBSCRIPTION_IS_NOT_ACTIVE) {
                    alertResponseError(this.$t("message_error.SUBSCRIPTION_IS_NOT_ACTIVE"));
                } else if (error.response.data.errorCode === ERRORS_CODE.ORGANIZATION_NOT_FOUND) {
                    alertResponseError(this.$t("message_error.CAN_NOT_START_PLAN"));
                }else {
                    return alertResponseError(error);
                }
                
            });
        },
        updateKintoneFields(aiModelId) {
            const kintoneField = this.$refs.aiModelField.getDataInputAndOutput();
            AIModelService.updateKintoneFields(aiModelId, kintoneField).then((response) => {
                if (response.data.success) {
                    // set auto generate and record query
                    this.$router.push({ name: 'aimodel' });
                }
            }).catch((error) => {
                alertResponseError(error);
            });
        },
        mapDataToKintoneField(data) {
            return data.map((field, index) => {
                return {
                    "index": index,
                    "label": field.kintone_field_name,
                    "code": field.kintone_field_code,
                    "type": field.kintone_field_type,
                    "output_type": field.type,
                    "output_field_name": field.output_kintone_field_name,
                    "output_field_code": field.output_kintone_field_code,
                    "maxValue": field.kintone_field_maxValue !== undefined ? (field.kintone_field_maxValue != "" ? field.kintone_field_maxValue : 0) : 0,
                    "minValue": field.kintone_field_minValue !== undefined ? (field.kintone_field_minValue != "" ? field.kintone_field_minValue : 0) : 0,
                    "options": field.kintone_field_options !== undefined ? field.kintone_field_options : null,
                    "feature_importance": field.feature_importance !== undefined ? (field.feature_importance != "" ? field.feature_importance : 0) : 0,
                };
            });
        },
        updateSummarizePeriod(newValue) {
            this.aiModel.summarize_period = newValue;
        },
        updateSummarizeKintoneDateField(newValue) {
            this.aiSummarizeDateField = newValue;
            this.aiModel.summarize_kintone_field_name = newValue.label ?? '';
            this.aiModel.summarize_kintone_field_code = newValue.code ?? '';
            this.aiModel.summarize_kintone_field_type = newValue.type ?? '';
        },
        async fetchInitialData(aiModelId) {
            await this.getAIModelWithId(aiModelId);
            await this.getListInputsAndOutput(aiModelId);
            this.getKintoneFields();
        },
    },

    created() {
        document.title = this.$t(`${this.$route.meta.title}.title_page`);
        let model = JSON.parse(localStorage.getItem('selected_ai_model'));
        let aiModelId = null;
        if (model) {
            aiModelId = model.id;
        } else {
            aiModelId = this.$route.params.id;
        }
        this.isCreate = aiModelId ? false : true;
        if (!this.isCreate) {
            this.fetchInitialData(aiModelId);
        }
    },
    watch: {
        'aiModel.type'(newAIModelType) {
            this.aiModelData = []
            this.aiModelSavingPredictionData = []
            if (newAIModelType === AI_MODEL_TYPE.neural_network) {
                this.aiModel.kintone_app_id_2 = '';
                this.aiModel.kintone_app_name_2 = '';
                this.aiModel.summarize_period = SUMMARIZE_PERIOD.monthly;
                this.aiModel.summarize_kintone_field_name = '';
                this.aiModel.summarize_kintone_field_code = '';
                this.aiModel.summarize_kintone_field_type = '';
                this.aiSummarizeDateField = {};
            }
        }
    },
    computed: {
        kintoneNameErrors() {
            if (!this.$v.aiModel.name.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.name.$params.maxLength.max });
            }
            return null;
        },
        kintoneSubDomainErrors() {
            if (!this.$v.aiModel.kintone_sub_domain.required) {
                return this.$t("common_errors.required", { field: this.$t("ai_model.kintone_sub_domain") });
            }
            if (!this.$v.aiModel.kintone_sub_domain.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_sub_domain.$params.maxLength.max });
            }
            return null;
        },
        kintoneDomainErrors() {
            if (!this.$v.aiModel.kintone_domain.required) {
                return this.$t("common_errors.required", { field: this.$t("ai_model.kintone_domain") });
            }
            if (!this.$v.aiModel.kintone_domain.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_domain.$params.maxLength.max });
            }
            return null;
        },
        kintoneLoginNameErrors() {
            if (!this.$v.aiModel.kintone_login_name.required) {
                return this.$t("common_errors.required", { field: this.$t("ai_model.kintone_login_name") });
            }
            if (!this.$v.aiModel.kintone_login_name.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_login_name.$params.maxLength.max });
            }
            return null;
        },
        kintonePasswordErrors() {
            if (!this.$v.aiModel.kintone_password.required) {
                return this.$t("common_errors.required", { field: this.$t("ai_model.kintone_password") });
            }
            if (!this.$v.aiModel.kintone_password.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_password.$params.maxLength.max });
            }
            return null;
        },
        modelTypeErrors() {
            if (!this.$v.aiModel.type.required) {
                return this.$t("common_errors.required", { field: this.$t("ai_model.type") });
            }
            return null;
        },
        kintoneAppId() {
            if (!this.$v.aiModel.kintone_app_id.required) {
                return this.$t("common_errors.required", { field: this.aiModel.type == AI_MODEL_TYPE.neural_network ? this.$t("ai_model.kintone_app_id") : this.$t("ai_model.kintone_app_id_data") });
            }
            if (!this.$v.aiModel.kintone_app_id.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_app_id.$params.maxLength.max });
            }
            return null;
        },
        kintoneAppId2() {
            if (this.aiModel.type === AI_MODEL_TYPE.time_series && !this.$v.aiModel.kintone_app_id_2.required) {
                return this.$t("common_errors.required", { field: this.$t("ai_model.kintone_app_id_predict_data") });
            }
            if (!this.$v.aiModel.kintone_app_id_2.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_app_id_2.$params.maxLength.max });
            }
            if (!this.$v.aiModel.kintone_app_id_2.notSameAsKintoneAppId) {
                return this.$t("common_errors.not_same_as", { field2: this.$t("ai_model.kintone_app_id_predict_data"), field1: this.$t("ai_model.kintone_app_id_data") });
            }
            return null;
        },
        kintoneAppNameErrors() {
            if (!this.$v.aiModel.kintone_app_name.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_app_name.$params.maxLength.max });
            }
            return null;
        },
        kintoneAppName2Errors() {
            if (!this.$v.aiModel.kintone_app_name_2.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_app_name_2.$params.maxLength.max });
            }
            return null;
        },
        kintoneBasicUsernameErrors() {
            if (!this.$v.aiModel.kintone_basic_username.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_basic_username.$params.maxLength.max });
            }
            return null;
        },
        kintoneBasicPasswordErrors() {
            if (!this.$v.aiModel.kintone_basic_password.maxLength) {
                return this.$t("common_errors.max_lenght", { max: this.$v.aiModel.kintone_basic_password.$params.maxLength.max });
            }
            return null;
        }
    },
    validations() {
        return {
            aiModel: {
                id: { maxLength: maxLength(26) },
                name: { maxLength: maxLength(64) },
                kintone_sub_domain: { required, maxLength: maxLength(32) },
                kintone_domain: { required, maxLength: maxLength(128) },
                kintone_login_name: { required, maxLength: maxLength(128) },
                kintone_password: { required, maxLength: maxLength(128) },
                type: { required },
                kintone_app_id: { required, maxLength: maxLength(128) },
                kintone_app_name: { maxLength: maxLength(64) },
                kintone_app_id_2: {
                    required: requiredIf(() => {
                        return this.aiModel.type === AI_MODEL_TYPE.time_series;
                    }),
                    maxLength: maxLength(128),
                    notSameAsKintoneAppId: (value) => value !== this.aiModel.kintone_app_id || !value
                },
                kintone_app_name_2: { maxLength: maxLength(64) },
                kintone_basic_username: { maxLength: maxLength(128) },
                kintone_basic_password: { maxLength: maxLength(128) },
            }
        }
    }
}